import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Button from 'components/Button/Button';
import { BUTTON_VARIANT } from 'constants/interfaces';

import type IButtonDropDawn from './interfaces/IButtonDropDawn';

import styles from './scss/ButtonDropDawn.module.scss';

function ButtonDropDawn({
  title,
  onClick,
  className,
  options,
}: IButtonDropDawn) {
  const { t } = useTranslation();
  const [openDropDown, setOpenDropDown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setOpenDropDown(false);
      }
    };

    if (openDropDown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openDropDown]);

  const onHandleOpenClick = () => {
    setOpenDropDown(!openDropDown);
  };

  const onClickOption = (option: string) => {
    setOpenDropDown(false);
    if (onClick) {
      onClick(option);
    }
  };

  return (
    <div ref={dropdownRef} className={`${styles.root} ${className}`}>
      <Button
        title={title}
        variant={BUTTON_VARIANT.primary}
        className={styles.button}
        onClick={onHandleOpenClick}
      />
      <div className={clsx(styles.dropDown, { [styles.open]: openDropDown })}>
        {options.map((option, index) => (
          <Button
            key={[option, index].join('_')}
            title={t(`common.${option}`)}
            variant={BUTTON_VARIANT.ghost}
            className={styles.buttonOption}
            onClick={() => onClickOption(option)}
          />
        ))}
      </div>
    </div>
  );
}

export default ButtonDropDawn;
